import vslQueries from "$/lib/queries/vsl-queries"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/vsl/")({
  loader: async ({ context: { queryClient } }) => {
    queryClient.prefetchQuery(vslQueries.list())
    return { crumb: "VSL" }
  },
})
